import { v4 as uuidv4 } from 'uuid';

import type { ScenarioDefinitionV1 } from 'api/scenarios';

/** シナリオ名の上限。作成APIと同じ値を画面側でも守る。 */
export const SCENARIO_NAME_MAX = 100;
const COPY_SUFFIX = 'のコピー';

/**
 * コピー先の管理名を作る。上限を超える場合は元の名前側を削り、接尾辞は必ず残す。
 * @param name コピー元の管理名
 * @returns 上限に収めた「◯◯のコピー」
 */
export function copyName(name: string): string {
  const room = SCENARIO_NAME_MAX - COPY_SUFFIX.length;
  return `${name.length > room ? name.slice(0, room) : name}${COPY_SUFFIX}`;
}

/**
 * step・messageのIDを振り直す。元シナリオとIDを共有すると、条件分岐の行き先や
 * 統計の突き合わせが元シナリオを指したまま残るため、コピー時に必ず作り直す。
 * @param definition コピー元の編集中definition
 * @returns IDを振り直し、条件分岐の参照も張り替えたdefinition
 */
export function reissueDefinitionIds(definition: ScenarioDefinitionV1): ScenarioDefinitionV1 {
  const stepIds = new Map(definition.steps.map((step) => [step.id, uuidv4()]));
  return {
    ...definition,
    steps: definition.steps.map((step) => ({
      ...step,
      id: stepIds.get(step.id)!,
      falseTargetStepId: step.falseTargetStepId ? stepIds.get(step.falseTargetStepId) ?? null : null,
      messages: step.messages.map((message) => ({ ...message, id: uuidv4() })),
    })),
  };
}
